export const TOGGLE_SIDEBAR = "collapseSidebar"
export const OUTER_TABLE_CHANGE = "outerTableChange"

export const toggleSidebarEvent = new Event(TOGGLE_SIDEBAR);
export const outerTableChangeEvent = new Event(OUTER_TABLE_CHANGE, {"bubbles":true, "cancelable":true})